/**
 * Google Analytics Event Tracking
 * Trackea clics en botones con atributos data-ga-*
 */

(function() {
  'use strict';
  
  // Esperar a que el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }

  function initTracking() {
    console.log('🔍 Inicializando tracking de Google Analytics');
    
    // Verificar si Google Analytics está disponible
    const hasGA4 = typeof gtag !== 'undefined';
    const hasGTM = typeof dataLayer !== 'undefined';
    const hasUniversalGA = typeof ga !== 'undefined';
    
    if (!hasGA4 && !hasGTM && !hasUniversalGA) {
      console.warn('⚠️ Google Analytics no detectado. Instala GA4 o GTM primero.');
      return;
    }
    
    console.log('✅ Google Analytics detectado:', {
      GA4: hasGA4,
      GTM: hasGTM,
      Universal: hasUniversalGA
    });

    /**
     * Envía un evento a Google Analytics
     * @param {string} eventName - Nombre del evento
     * @param {object} params - Parámetros del evento
     */
    function sendEvent(eventName, params) {
      console.log('📊 Enviando evento:', eventName, params);
      
      // Google Analytics 4
      if (hasGA4) {
        gtag('event', eventName, params);
      }
      
      // Google Tag Manager
      if (hasGTM) {
        window.dataLayer.push({
          'event': eventName,
          ...params
        });
      }
      
      // Universal Analytics (legacy - por si todavía lo usas)
      if (hasUniversalGA && !hasGA4) {
        ga('send', 'event', 
          params.event_category || 'general',
          eventName,
          params.event_label || '',
          params.value || 0
        );
      }
    }

    // Buscar todos los botones con tracking
    const trackedButtons = document.querySelectorAll('[data-ga-tracking="true"]');
    console.log(`🎯 Encontrados ${trackedButtons.length} botones para trackear`);
    
    // Agregar listener a cada botón
    trackedButtons.forEach(function(button, index) {
      const eventName = button.getAttribute('data-ga-event') || 'button_click';
      const category = button.getAttribute('data-ga-category') || 'button';
      const label = button.getAttribute('data-ga-label') || button.innerText;
      const value = button.getAttribute('data-ga-value') || '';
      const buttonId = button.getAttribute('data-button-id') || `button-${index}`;
      
      console.log(`  ✓ Botón ${index + 1}: "${label}" (${eventName})`);
      
      // Escuchar el clic
      button.addEventListener('click', function(e) {
        const eventData = {
          'event_category': category,
          'event_label': label,
          'button_id': buttonId,
          'button_text': this.innerText,
          'destination_url': value,
          'page_location': window.location.href,
          'page_title': document.title
        };
        
        sendEvent(eventName, eventData);
      });
    });
  }
})();
